import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { loadScript as load } from '@sie/web-common-utils';
var cookieMonsterUrl = 'https://id.{envExceptNp}.sonyentertainmentnetwork.com/id/cm/siews1lib.js';
/** Specs and documentation for cookie monster
 * @see {@link `https://confluence.sie.sony.com/display/ID/CookieMonster+API+spec`}
 */

var CookieMonster = /*#__PURE__*/function () {
  function CookieMonster() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        domain = _ref.domain,
        url = _ref.url,
        _ref$npEnvironment = _ref.npEnvironment,
        npEnvironment = _ref$npEnvironment === void 0 ? 'e1-np' : _ref$npEnvironment,
        loadScript = _ref.loadScript,
        language = _ref.language,
        country = _ref.country;

    _classCallCheck(this, CookieMonster);

    _defineProperty(this, "_url", '');

    _defineProperty(this, "_offCallbacks", []);

    _defineProperty(this, "_isBootstrapped", false);

    _defineProperty(this, "_isReady", false);

    _defineProperty(this, "_deferredCalls", []);

    _defineProperty(this, "_validateEventHandler", function (type, cb) {
      return typeof cb === 'function' && type === 'privacyConsentChange';
    });

    this._domain = domain;
    this._language = language;
    this._country = country;
    this._loadScript = loadScript || load;

    if (url) {
      this._url = url;
    } else {
      this._url = cookieMonsterUrl.replace('{envExceptNp}.', npEnvironment === 'np' ? '' : "".concat(npEnvironment, "."));
    }
  }
  /**
   * Set the country to use for future calls
   */


  _createClass(CookieMonster, [{
    key: "setCountry",
    value: function setCountry(country) {
      this._country = country;
    }
    /**
     * Set the language to use for future calls to Prompt
     */

  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      this._language = language;
    }
    /**
     * Bootstrap the JS library that makes this class works
     * @returns {Promise} resolves when the library is ready to use
     */

  }, {
    key: "bootstrap",
    value: function bootstrap() {
      var _this = this;

      if (window.SIEWS1lib) {
        this._isBootstrapped = true;
        this._isReady = true;
        return this._bootstrapPromise || Promise.resolve();
      }

      if (this._isBootstrapped) return this._bootstrapPromise || Promise.resolve();
      this._isBootstrapped = true;
      this._bootstrapPromise = new Promise(function (resolve, reject) {
        return _this._loadScript({
          src: _this._url,
          onload: function onload() {
            _this._isReady = true;

            _this._dequeueCalls();

            resolve();
          },
          onerror: function onerror(e) {
            console.log('ERROR loading cookie monster', e);
            reject(e);
          }
        });
      });
      return this._bootstrapPromise;
    }
  }, {
    key: "_queueCall",
    value: function _queueCall(call) {
      var _this2 = this;

      this._deferredCalls.push(call);

      return function () {
        _this2._deferredCalls = _this2._deferredCalls.filter(function (x) {
          return x !== call;
        });
      };
    }
  }, {
    key: "_dequeueCalls",
    value: function _dequeueCalls() {
      var _this3 = this;

      this._deferredCalls.forEach(function (_ref2) {
        var fn = _ref2.fn,
            _ref2$args = _ref2.args,
            args = _ref2$args === void 0 ? [] : _ref2$args;
        return _this3[fn].apply(_this3, _toConsumableArray(args));
      });

      this._deferredCalls = [];
    }
  }, {
    key: "once",

    /**
     * Establish a listener for the given event type to be called only on the first change
     * @param {string} type event type ["privacyConsentChange"]
     * @param {Function} cb the event callback to be called when the setting changes
     * @returns {Function} function to remove listener
     */
    value: function once(type, cb) {
      var off = this.on(type, function (event) {
        cb(event);
        off();
      });
      return off;
    }
    /**
     * Establish a listener for the given event type
     * @param {string} type event type ["privacyConsentChange"]
     * @param {Function} cb the event callback to be called when the setting changes
     * @returns {Function} function to remove listener
     */

  }, {
    key: "on",
    value: function on(type, cb) {
      var _this4 = this;

      if (!this._validateEventHandler(type, cb)) return function () {};

      var callback = function callback(value) {
        return cb({
          value: value
        });
      };

      var off = function off() {
        window.SIEWS1lib.removeEventListener('onChangedPlatformPrivacyWs1', callback);
      };

      if (!this._isReady) {
        var removeQueuedCall = this._queueCall({
          fn: 'on',
          args: [type, cb]
        });

        return function () {
          removeQueuedCall();
          if (_this4._isReady) off();
        };
      }

      window.SIEWS1lib.addEventListener('onChangedPlatformPrivacyWs1', callback);

      this._offCallbacks.push(off);

      return function () {
        off();
        _this4._offCallbacks = _this4._offCallbacks.filter(function (x) {
          return x !== off;
        });
      };
    }
    /**
     * Remove all event listeners
     */

  }, {
    key: "off",
    value: function off() {
      if (!this._isReady) {
        this._queueCall({
          fn: 'off'
        });

        return;
      }

      this._offCallbacks.forEach(function (off) {
        return off();
      });
    }
    /**
     * Get the users current privacy preference setting
     * @param {Object} [options]
     * @param {string} [options.country] see documentation for values, will use set value if
     *  not passed
     * @returns {Promise.<string>} see documentation for values (all, exempt, minimal, null, etc);
     */

  }, {
    key: "getPrivacyPreference",
    value: function getPrivacyPreference() {
      var _this5 = this;

      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          country = _ref3.country;

      return this.bootstrap().then(function () {
        return window.SIEWS1lib.getPlatformPrivacyWs1({
          country: country || _this5._country
        });
      });
    }
    /**
     * Prompts the user for their privacy preferences / cookie usage if required by law
     * and returns their selected value once set
     * @param {Object} options
     * @param {HTMLElement} options.element the root element to add the consent prompt UI to
     * @param {boolean} options.force if true will always prompt for preference even if set already
     * @param {string} options.type either `full` or `settings-only` UI
     * @param {boolean} options.disableFixedTop whether to disable fixed position at top
     * @param {string} [options.language] see documentation for values, will use set value if
     *  not passed
     * @param {string} [options.country] see documentation for values, will use set value if
     *  not passed
     * @returns {Promise.<string>} user selected value
     */

  }, {
    key: "promptForPrivacyPreference",
    value: function () {
      var _promptForPrivacyPreference = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var options,
            element,
            force,
            _options$type,
            type,
            _options$disableFixed,
            disableFixedTop,
            country,
            language,
            level,
            useDomain,
            el,
            ppUrl,
            show,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                element = options.element, force = options.force, _options$type = options.type, type = _options$type === void 0 ? 'full' : _options$type, _options$disableFixed = options.disableFixedTop, disableFixedTop = _options$disableFixed === void 0 ? false : _options$disableFixed;
                country = options.country || this._country;
                language = options.language || this._language;
                _context.next = 6;
                return this.bootstrap();

              case 6:
                if (force) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return this.getPrivacyPreference({
                  country: country
                });

              case 9:
                level = _context.sent;

                if (!level) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", level);

              case 12:
                if (!(type === 'none')) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", null);

              case 14:
                useDomain = this._domain || (window.location.hostname === 'localhost' ? undefined : '.playstation.com');
                el = element || document.getElementById('js-SIEWS1lib-header') || document.body; // TODO: this was not localized in BH :|. Get map of supported locales for this link

                ppUrl = 'https://www.playstation.com/en-gb/legal/privacy-policy/';
                show = type === 'full' ? window.SIEWS1lib.show : window.SIEWS1lib.showSettings; // Show returns sync status with codes
                // {code: "00", message: "successful"} UI was successfully displayed?
                // {code: "01", message: "configured"} cookie value already set
                // {code: "99", message: "exempt"} is not target country

                show({
                  country: country,
                  language: language,
                  force: force,
                  element: el,
                  pp_url: ppUrl,
                  domain: useDomain,
                  disabled_fixed_top: disableFixedTop
                });
                return _context.abrupt("return", new Promise(function (resolve) {
                  return _this6.once('privacyConsentChange', function (_ref4) {
                    var value = _ref4.value;
                    return resolve(value);
                  });
                }));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function promptForPrivacyPreference() {
        return _promptForPrivacyPreference.apply(this, arguments);
      }

      return promptForPrivacyPreference;
    }()
  }]);

  return CookieMonster;
}();

export default CookieMonster;